<template>
  <div :class="$style.sectionBeAhead">
    <div class="container section">
      <p class="sub-title">Be Ahead</p>
      <h2 class="title">為您節省時間，<br class="pc-only" />輕鬆與您的客戶保持聯繫</h2>
      <div class="text-container">
        <p class="star-text ">預付方案自由組</p>
        <p class="plain-text">讓您自由組合適用項目及服務次數，快速設定各式療程方案，並於服務後準確記錄使用次數及使用期限，避免點數過期或抵扣爭議！</p>
        <p class="star-text">單店設定</p>
        <p class="plain-text">幫助您於品牌專屬預約網站建立店家資訊， 增強線上渠道的可見度，讓您的客戶能輕鬆查詢！</p>
        <p class="star-text">自動簡訊通知</p>
        <p class="plain-text plain-text--last">每月提供100封免費簡訊，由系統自動發送預約確認和提醒，還可針對溝通需要，讓您編寫簡訊寄送給客戶！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" module>
.sectionBeAhead {
  position: relative;
  background-image: url('@assets/dingbeauty-images/basic-plan/img_01@2.jpg');
  background-size: cover;
  background-position: 26% center;
  color: #fff;

  // Darken background
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    background: transparent linear-gradient(270deg, #c0975d00 0%, #58390b47 46%, #4129059a 100%) 0% 0% no-repeat padding-box;
    width: 100%;
    height: 100%;
  }

  :global {
    .pc-only {
      display: none;
    }

    .section {
      position: relative;
      z-index: 3;
    }

    .sub-title {
      font-size: 20px;
    }

    .title {
      text-align: center;
      font-size: 24px;
      margin-bottom: 28px;
    }

    .star-text {
      display: flex;
      justify-content: left;
      align-items: center;
      font-size: 18px;

      &::before {
        content: '';
        display: inline-block;
        background-image: url('~@assets/dingbeauty-images/basic-plan/icon_shiny2_white.svg');
        background-size: cover;
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }

    .plain-text {
      font-size: 14px;
      margin-bottom: 28px;
    }

    .plain-text--last {
      margin-bottom: 0;
    }
  }
}

@media (min-width: 1200px) {
  .sectionBeAhead {
    text-align: left;
    background-position: center;

    :global {
      .pc-only {
        display: inline;
      }

      .text-container {
        max-width: 320px;
      }

      .sub-title {
        font-size: 22px;
      }

      .title {
        font-size: 40px;
        text-align: left;
        margin-bottom: 60px;
      }

      .title--last {
        margin-bottom: 4rem;
      }

      .star-text {
        font-size: 24px;
        justify-content: left;

        &::before {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }

      .plain-text {
        font-size: 16px;
        margin-bottom: 3rem;
      }
    }
  }
}
</style>
